<template>
    <div v-if="type === 'tabs'">
        <ul class="nav nav-tabs nav-tabs-highlight mb-0" :class="[ bgClass, { 'pl-2 pt-2': card } ]">
            <li v-for="link in visibleLinks" :key="link.name" class="nav-item">
                <a v-if="link.url" :href="link.url" class="nav-link">
                    {{ link.text }}
                </a>
                <router-link v-else :to="link" class="nav-link" exact-path-active-class="active" exact-active-class="active" active-class="active" exact-path>
                    {{ link.text }}
                </router-link>
            </li>
        </ul>

        <div class="tab-content card-body bg-white" :class="{ 'card border-top-0 rounded-top-0 mb-0': !card }">
            <div class="tab-pane fade show active" id="highlighted-tab1">
                <slot v-if="hasDefaultSlot"></slot>
                <router-view v-else></router-view>
            </div>
        </div>
    </div>
    <div v-else-if="type === 'buttons'">
        <div class="btn-group">
            <template v-for="link in visibleLinks"  class="nav-item">
                <a v-if="link.url" :href="link.url" :key="link.name" class="nav-link">
                    {{ link.text }}
                </a>
                <router-link v-else :to="link" :key="link.name" class="btn btn-light" exact-path-active-class="active" exact-active-class="active" active-class="active" exact-path>
                    {{ link.text }}
                </router-link>
            </template>
        </div>

        <div class="mt-3">
            <slot v-if="hasDefaultSlot"></slot>
            <router-view v-else></router-view>
        </div>
    </div>
</template>
<script>
import { hasPermission } from '@services/Helpers';

export default {
    name: 'LimitlessCardTabsView',
    props: {
        type: {
            type: String,
            default: 'tabs',
        },
        bgClass: {
            type: String,
            default: '',
        },
        card: {
            type: Boolean,
            default: false,
        },
        links: {
            type: Array,
            default() {
                return [];
            },
        },
        data: {},
    },
    computed: {
        visibleLinks() {
            return this.links.filter((link) => {
                const route = this.getRoute(link.name);
                if (route) {
                    if (Object.prototype.hasOwnProperty.call(route.meta, 'permission')) {
                        return route.meta.permission.some((item) => this.hasPermission(item));
                    }

                    if (Object.prototype.hasOwnProperty.call(link, 'permission')) {
                        return link.permission.some((item) => this.hasPermission(item));
                    }

                    return true;
                }

                return false;
            });
        },
        hasDefaultSlot() {
            return !!this.$slots.default;
        },
    },
    methods: {
        hasPermission,
        getRoute(name) {
            return this.$router.getRoutes().find((route) => route.name === name);
        },
    },
};
</script>
<style scoped>
.icon-large {
    height: 64px;
    width: 64px;
    margin: 1rem;
}
.no-permission-content {
    display: flex;
    height: 200px;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;
}
</style>
